import { Emoji } from 'images'

export const SWEATBITS_TEXT = (
  <span className="inline-flex items-center">
    <span className="text-green">S</span>
    <Emoji name="sweatbits" />
    <span className="text-green">eat</span>Bits
  </span>
)
